import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import { Email } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniContact;
var iniPhase;
var iniCampaign;


class SalesEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.salesId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            SalesId: data[0].salesId,
            Name: data[0].name,
            Description: data[0].description,
            Campaign_Id: data[0].campaign_Id,
            Contact_Id: data[0].contact_Id,
            Phase_Id: data[0].phase_Id,
            Amount: data[0].amount,
            ExternalLink: data[0].externalLink,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            campaign: (Object.keys(props.lookupLists.campaign).map((d) => ({ value: d, label: props.lookupLists.campaign[d] })) || []),
            contact: (Object.keys(props.lookupLists.contact).map((d) => ({ value: d, label: props.lookupLists.contact[d] })) || []),
            phase: (Object.keys(props.lookupLists.phase).map((d) => ({ value: d, label: props.lookupLists.phase[d] })) || []),
                
        };

    }

    UNSAFE_componentWillMount() {

        iniCampaign = this.state.campaign.find(({ value }) => value === (this.state.Campaign_Id || '').toString());
        iniContact = this.state.contact.find(({ value }) => value === (this.state.Contact_Id || '').toString());
        iniPhase = this.state.phase.find(({ value }) => value === (this.state.Phase_Id || '').toString());
        
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            SalesId: this.state.data[0].salesId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Campaign_Id: this.state.data[0].campaign_Id,
            Contact_Id: this.state.data[0].contact_Id,
            Phase_Id: this.state.data[0].phase_Id,
            Amount: this.state.data[0].amount,
            ExternalLink: this.state.data[0].externalLink,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            SalesId: this.state.SalesId,
            Name: this.state.Name,
            Description: this.state.Description,
            Campaign_Id: this.state.Campaign_Id,
            Contact_Id: this.state.Contact_Id,
            Phase_Id: this.state.Phase_Id,
            Amount: this.state.Amount,
            ExternalLink: this.state.ExternalLink,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, campaign, contact, phase } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Sales.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Sales.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Sales.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniCampaign}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Campaign_Id')}
                                options={campaign}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Sales.Columns[3]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniContact}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Contact_Id')}
                                options={contact}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Sales.Columns[4]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniPhase}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Phase_Id')}
                                options={phase}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Sales.Columns[5]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Sales.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Amount}
                            onChange={this.handleChange('Amount')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Sales.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "SalesEdit" })(SalesEdit);
